import api from "../../index";

export const GetAllwalletDepositApi = (params) => api.get(`wallet/getall-wallet-deposit?${params}`);